import cn from 'clsx';
import React, { type FC, type PropsWithChildren } from 'react';
import { type DeviceTypeEnum } from '../../../types/DeviceType';
import { Spinner } from '../../Spinner';
import { DH } from '../../../utils/DataHook';
import s from './Elements.scss';

export const Line: FC<PropsWithChildren> = (props) => (
  <section data-hook={DH.UserInfoForm.Line} className={s.line}>
    {props.children}
  </section>
);
Line.displayName = 'Line';

interface ILabelProps {
  appearance: DeviceTypeEnum;
  title: string;
  htmlFor?: string;
  required?: boolean;
}

export const Label: FC<PropsWithChildren<ILabelProps>> = (props) => (
  <label className={cn(s.labelTitle, props.appearance === 'mobile' && s.mobile)} htmlFor={props.htmlFor}>
    {props.required ? <span aria-hidden={'true'}>* </span> : null}
    {props.title}
  </label>
);
Label.displayName = 'Label';

export const Loader: FC = () => (
  <div className={s.loaderContainer} data-hook={DH.UserInfoForm.CountriesLoader}>
    <Spinner size="small" />
  </div>
);
Loader.displayName = 'Loader';

export const CountryContainer: FC<PropsWithChildren<{ appearance: DeviceTypeEnum }>> = (props) => (
  <div className={cn(s.countryDDContainer, props.appearance === 'mobile' && s.mobile)}>{props.children}</div>
);
CountryContainer.displayName = 'CountryContainer';
